import * as AccessoryListings from './accessoryListings';
import * as Achievements from './achievements';
import * as AppConfig from './appConfig';
import * as Archetypes from './archetypes';
import * as Assets from './assets';
import * as Auth from './auth';
import * as AuthService from './auth-service';
import * as Banlists from './banlists';
import * as BanlistPredictions from './banlistPredictions';
import * as GameFormats from './game-formats';
import * as Boxes from './boxes';
import * as Bundles from './bundles';
import * as Cache from './cache';
import * as CardDatabase from './card-database';
import * as Cards from './cards';
import * as Challonge from './challonge';
import * as ContentCreators from './contentCreators';
import * as Countries from './countries';
import * as Credits from './credits';
import * as Dashboard from './dashboard';
import * as DeckChecks from './deck-checks';
import * as Discord from './discord';
import * as DeckListings from './deckListings';
import * as Decklists from './decklists';
import * as Entrepreneurs from './entrepreneurs';
import * as Events from './events';
import * as GameTypes from './gameTypes';
import * as Gamification from './gamification';
import * as GoogleSheets from './google-sheets';
import * as HallOfFame from './hallOfFame';
import * as ImageGeneratorSettings from './imageGeneratorSettings';
import * as Inventories from './inventories';
import * as LPButtonsSettings from './lpButtonsSettings';
import * as Judges from './judges';
import * as JudgeCalls from './judge-calls';
import * as PublicEvents from './publicEvents';
import * as Leagues from './leagues';
import * as KcgnSnapshots from './kcgnSnapshots';
import * as LimitlessPending from './limitlessPending';
import * as ChallongePending from './challongePending';
import * as Listings from './listings';
import * as Locations from './locations';
import * as Logs from './logs';
import * as Marketplace from './marketplace';
import * as MatchNotes from './match-notes';
import * as MetaAnalytics from './metaAnalytics';
import * as MetaDecks from './metaDecks';
import * as Missions from './missions';
import * as PlayerLog from './playerLog';
import * as Notifications from './notifications';
import * as Orders from './orders';
import * as Organizers from './organizers';
import * as Penalties from './penalties';
import * as Platforms from './platforms';
import * as Provinces from './provinces';
import * as Ranking from './ranking';
import * as Regions from './regions';
import * as Rulings from './rulings';
import * as SellerSettings from './sellerSettings';
import * as Sets from './sets';
import * as Stickers from './stickers';
import * as Stores from './stores';
import * as StreamControl from './stream-control';
import * as StreamMatches from './stream-matches';
import * as Streaming from './streaming';
import * as SuperYacs from './superYacs';
import * as DuelingBook from './duelingBook';
import * as DecklistSubmissions from './decklistSubmissions';
import * as ReplayVideos from './replayVideos';
import * as Sleeves from './sleeves';
import * as Playmats from './playmats';
import * as Tasks from './tasks';
import * as Teams from './teams';
import * as TopdeckPending from './topdeckPending';
import * as TournamentDecklists from './tournamentDecklists';
import * as Tournaments from './tournaments';
import * as Users from './users';
import * as UserSettings from './userSettings';
import * as Wishlists from './wishlists';
import * as XP from './xp';

const SDK = {
  AccessoryListings,
  Achievements,
  AppConfig,
  Archetypes,
  Assets,
  Auth,
  AuthService,
  Banlists,
  BanlistPredictions,
  GameFormats,
  Boxes,
  Bundles,
  Cache,
  CardDatabase,
  Cards,
  Challonge,
  ContentCreators,
  Countries,
  Credits,
  Dashboard,
  DeckChecks,
  Discord,
  DeckListings,
  Decklists,
  Entrepreneurs,
  Events,
  GameTypes,
  Gamification,
  GoogleSheets,
  HallOfFame,
  ImageGeneratorSettings,
  Inventories,
  LPButtonsSettings,
  Judges,
  JudgeCalls,
  PublicEvents,
  Leagues,
  KcgnSnapshots,
  LimitlessPending,
  ChallongePending,
  Listings,
  Locations,
  Logs,
  Marketplace,
  MatchNotes,
  MetaAnalytics,
  MetaDecks,
  Missions,
  Notifications,
  PlayerLog,
  Orders,
  Organizers,
  Penalties,
  Platforms,
  Provinces,
  Ranking,
  Regions,
  Rulings,
  SellerSettings,
  Sets,
  Stickers,
  Stores,
  StreamMatches,
  StreamControl,
  Streaming,
  SuperYacs,
  DuelingBook,
  DecklistSubmissions,
  ReplayVideos,
  Sleeves,
  Playmats,
  Tasks,
  Teams,
  TopdeckPending,
  TournamentDecklists,
  Tournaments,
  Users,
  UserSettings,
  Wishlists,
  XP,
};

export { getApiEndpoint, setApiEndpoint, setAppInfo, getAppInfo } from './api.types';
export { setServiceApiKey } from './query-client';

export default SDK;
